import React from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import { GlobalStyle as CeciGlobalStyle } from "ceci-ui";
import { GlobalStyle as AppGlobalStyle } from './styles';
import Header from '../components/Header';
import Routes from './routes';

function App() {
  return (
    <>
      <CeciGlobalStyle />
      <AppGlobalStyle />
      <Router>
        <Header />
        <Routes />
      </Router>
    </>
  );
}

export default App
